import React, { useMemo, useState } from 'react';
import { subDetailsItem } from '../../../pages/PaymentIntegrityPage/PaymentIntegrity.types';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import componentConstants from '../../../core-utils/messages/componentConstants';
import SubDetailsCard from '../SubDetailsCard';

interface SubDetailsGridProps {
  subDetails: subDetailsItem[][];
}

const PAGE_SIZE = 10;

const SubDetailsGrid: React.FC<SubDetailsGridProps> = ({ subDetails }) => {
  const { classes } = makeStyles()({
    text: {
      textDecoration: 'dashed',
      textDecorationLine: 'underline',
      textDecorationThickness: '0.5px',
      textUnderlineOffset: '5px',
    },
  })();

  const [visibleCount, setVisibleCount] = useState<number>(PAGE_SIZE);

  if (!subDetails.length) {
    return null;
  }
  const visibleSubDetails = useMemo(() => subDetails.slice(0, visibleCount), [
    subDetails,
    visibleCount,
  ]);

  const hasMore = visibleCount < subDetails.length;

  return (
    <>
      {visibleSubDetails.map((claimDetails, claimIndex) => (
        <SubDetailsCard claimDetails={claimDetails} key={claimIndex} />
      ))}

      {hasMore && (
        <Box
          style={{
            display: 'flex',
            marginBottom: '20px',
            justifyContent: 'center',
          }}
        >
          <Typography
            fontSize="14px"
            lineHeight="28px"
            fontType="medium"
            textColor={patientAccessTheme.palette.primary[500]}
            className={classes.text}
            cursor="pointer"
            onClick={() => setVisibleCount((c) => c + PAGE_SIZE)}
          >
            {componentConstants.MOLECULES.MEDICAL_HISTORY_TIMELINE.LOAD_MORE}
          </Typography>
        </Box>
      )}
    </>
  );
};

export default SubDetailsGrid;
